const DoesUserExist = `
    query($email: String!) {
        isEmailValid(email: $email)
    }
`;
export default DoesUserExist;